import React from 'react';
import { useSpinradContext } from '../../context/SpinradContext';
import { CoreVal, ValuesHead, ValuesRow, ValuesSection } from './styles';

const CoreValuesPanel: React.FC = () => {
  const { coreValues } = useSpinradContext();

  return (
    <ValuesSection>
      <ValuesHead>Unsere Kernwerte</ValuesHead>
      <ValuesRow>
        {coreValues.map(v => (
          <CoreVal key={v}>{v}</CoreVal>
        ))}
      </ValuesRow>
    </ValuesSection>
  );
};

export default CoreValuesPanel;
